<template>
  <button
    class="resolve-button"
    :class="{ 'resolve-button--loading': loading }"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <span v-if="loading" class="resolve-button-spinner"></span>
    <template v-else>
      {{ label }}
      <span class="resolve-button-indicator" v-if="showIndicator"></span>
    </template>
  </button>
</template>

<script>
export default {
  name: 'ResolveButton',
  props: {
    label: {
      type: String,
      default: 'Resolve'
    },
    showIndicator: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled && !this.loading) {
        this.$emit('click')
      }
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.resolve-button {
  min-height: 45px;
  font-size: 1rem;
  font-weight: 500;
  padding: 0 18px;
  border-radius: 4px;
  background: #FFF;
  border: 1px solid #d1d5db;
  outline: none;
  cursor: pointer;
  color: #374151;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  transition: all 0.15s ease;
}

.resolve-button:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #9ca3af;
}

.resolve-button:active:not(:disabled) {
  transform: scale(0.98);
}

.resolve-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.resolve-button--loading {
  cursor: wait;
}

.resolve-button-indicator {
  width: 8px;
  height: 8px;
  background: var(--color-primary, #6a16f0);
  border-radius: 50%;
  flex-shrink: 0;
}

.resolve-button-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
